import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShortlist } from '../context/ShortlistContext';
import '../styles/ShortlistButton.css';

const ShortlistButton = ({ carId, size = 'medium', showText = false }) => {
  const navigate = useNavigate();
  const { isShortlisted, addToShortlist, removeFromShortlist } = useShortlist();
  const [isAnimating, setIsAnimating] = useState(false);
  const shortlisted = isShortlisted(carId);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    setIsAnimating(true);
    
    if (shortlisted) {
      await removeFromShortlist(carId);
    } else {
      await addToShortlist(carId);
    }

    setTimeout(() => setIsAnimating(false), 300);
  };

  return (
    <button
      onClick={handleClick}
      className={`shortlist-btn shortlist-btn-${size} ${shortlisted ? 'shortlisted' : ''} ${isAnimating ? 'animating' : ''}`}
      title={shortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
    >
      <span className="heart-icon">{shortlisted ? '❤️' : '🤍'}</span>
      {showText && (
        <span className="shortlist-text">
          {shortlisted ? 'Shortlisted' : 'Shortlist'}
        </span>
      )}
    </button>
  );
};

export default ShortlistButton;